import { render } from "./leaves-index.vue?vue&type=template&id=4b165a56&scoped=true"
import script from "./leaves-index.vue?vue&type=script&lang=js"
export * from "./leaves-index.vue?vue&type=script&lang=js"

import "./leaves-index.vue?vue&type=style&index=0&id=4b165a56&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b165a56"]])

export default __exports__